<template>
  <div class="container" style="width: 100%; height: 100%">
    <div id="chinaMapbox" ref="chinaMapbox"></div>
    <img ref="bgRef" hidden src="../assets/chinabg.png" />
  </div>
</template>

<script>
import * as echarts from "echarts";
// import { ref } from 'vue';
import img from "../assets/imgOne.png";
import img2 from "../assets/imgOne_1.png";
// import chinaMap from './china.json';
import 晋城市 from "./json/晋城市.json";
import 沁水县 from "./json/沁水县.json";
import 城区 from "./json/城区.json";
import 高平市 from "./json/高平市.json";
import 陵川县 from "./json/陵川县.json";
import 阳城县 from "./json/阳城县.json";
import 泽州县 from "./json/泽州县.json";

export default {
  name: "chinaMapbox",
  props: {
    maxValue: Array,
  },

  data() {
    return {
      Value: [],
      bgRef: null,
      arrRetrun: ["晋城市"],
      MapName: 晋城市,
      citys: {
        晋城市: 晋城市,
        沁水县: 沁水县,
        城区: 城区,
        高平市: 高平市,
        陵川县: 陵川县,
        阳城县: 阳城县,
        泽州县: 泽州县,
      },

      /* 轮播tooltip */
      currentIndex: 0, // 当前显示 tooltip 的区域索引
      areaNames: ["城区", "高平市", "陵川县", "沁水县", "阳城县", "泽州县"], // 所有需要显示 tooltip 的区域名称
      tooltipInterval: null, // 定时器实例
      /* 轮播tooltip */

      selectName: null,
    };
  },
  watch: {
    maxValue: {
      handler(newVal, oldVal) {
        this.Value = newVal;
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    this.bgRef = this.$refs.bgRef;
    this.Value = this.maxValue;
    this.$nextTick(() => {
      this.initNYNM("晋城市", 晋城市);
    });
    window.addEventListener("resize", () => {
      this.$echarts.init(this.$refs.chinaMapbox).resize();
    });
  },
  methods: {
    initNYNM(name, json) {
      // console.log('name:', name);
      // console.log('json:', json);
      let that = this;
      // 基于准备好的dom，初始化echarts实例
      // 绘制图表

      // 1. 实例化对象
      let myChart = this.$echarts.init(this.$refs.chinaMapbox);
      // 2. 指定配置和数据

      /*获取地图数据*/

      function randomData() {
        return [Math.round(Math.random() * 1000), Math.random() > 0.6];
      }
      var gdGeoCoordMap = {
        //这是标记点的数据
        城区: [112.853106, 35.496641],
        高平市: [112.930691, 35.791355],
        陵川县: [113.278877, 35.775614],
        沁水县: [112.187213, 35.689472],
        阳城县: [112.422014, 35.482177],
        泽州县: [112.752789, 35.539858],
      };
      var gdGeoCoordMap1 = {
        //这是标记点px的数据
        城区: [355, 285],
        高平市: [383, 142],
        陵川县: [540, 177],
        沁水县: [175, 157],
        阳城县: [200, 311],
        泽州县: [355, 358],
      };

      var convertData = function (data) {
        console.info("data", data);
        var res = [];
        for (var i = 0; i < data.length; i++) {
          var geoCoord = gdGeoCoordMap[data[i].name];
          if (geoCoord) {
            res.push({
              name: data[i].name,
              value: geoCoord.concat(data[i].value),
              symbol:
                i == 3
                  ? "image://" + require("../assets/imgOne22.png")
                  : "image://" + require("../assets/imgOne22.png"),
            });
          }
        }
        return res;
      };
      var convertData1 = function (data) {
        var res = [];
        for (var i = 0; i < data.length; i++) {
          var geoCoord = gdGeoCoordMap[data[i].name];
          if (geoCoord) {
            res.push({
              name: data[i].name,
              value: geoCoord.concat(data[i].value),
            });
          }
        }
        return res;
      };
      var Points = [
        //这是展示弹框的数据
        { name: "城区", value: randomData() },
        { name: "高平市", value: randomData() },
        { name: "陵川县", value: randomData() },
        { name: "沁水县", value: randomData() },
        { name: "阳城县", value: randomData() },
        { name: "泽州县", value: randomData() },
      ];

      let points = Points.map((item) => {
        // console.log('points', item);
        if (name == "晋城市") {
          return item;
        }
        if (item.name == name) {
          return item;
        }
        return [];

        // if (item.name == name) {
        //   return item
        // }
      });
      // console.log('points:', points);

      echarts.registerMap(name, json);
      let option = {
        tooltip: {
          show: false,
          trigger: "item",
          backgroundColor: "transparent",
          borderColor: "transparent",
          extraCssText: "z-index:100;color:#fff;",
          confine: true, //是否将 tooltip 框限制在图表的区域内
          formatter: (params, ticket, callback) => {
            let cou = 0;
            //根据业务自己拓展要显示的内容
            var res = "";
            var name = params.name;
            var count = params.data.value[2];
            res = `<div style="width:70px; padding: 10px; position: absolute; top: 0; left:0;  border-radius: 4px;background:url( ${require("../assets/imgTwo.png")}) no-repeat center center /100% 100%;">
                             <div style='color:#F4BD59; font-size: 14px;'>${name}</div>
                             <div style="display: flex; align-items: center;padding-top: 6px;">
                               <span style="font-size: 12px;font-family: 'PangMenZhengDao'">${count}</span>
                             </div>
                          </div>`;
            return res;
          },
        },
        geo: [
          //地图背景
          {
            map: name,
            type: "geo",
            label: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false,
              },
            },
            roam: false,
            top: 50,
            bottom: 16,
            tooltip: {
              show: false,
            },
            itemStyle: {
              borderColor: "#8CDBF5", // 边界颜色
              borderWidth: 2, // 边界宽度
              areaColor: "#002B74",
              shadowColor: "rgba(63, 218, 255, 0.2)",
              shadowBlur: 6,
              shadowOffsetX: -5,
              shadowOffsetY: 5,
              // emphasis: {
              //   areaColor: "#0A94FF",
              //   areaColor: "rgba(45, 225, 237, 0.9)",
              //   shadowColor: "rgba(63, 218, 255, 0.2)",
              // },
            },
            // 后背景
            zoom: 0.7, //放大效果
          },
          {
            map: name,
            type: "geo",
            label: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false,
              },
            },
            roam: false,
            top: 45,
            bottom: 19,
            tooltip: {
              show: false,
            },
            itemStyle: {
              borderColor: "#8CDBF5", // 边界颜色
              borderWidth: 2, // 边界宽度
              areaColor: "#002B74",
              shadowColor: "rgba(63, 218, 255, 0)",
              shadowBlur: 6,
              shadowOffsetX: -5,
              shadowOffsetY: 5,
              // emphasis: {
              //   areaColor: "#0A94FF",
              //   areaColor: "rgba(45, 225, 237, 0.9)",
              //   shadowColor: "rgba(63, 218, 255, 0.2)",
              // },
            },
            // 后背景
            zoom: 0.7, //放大效果
          },
          {
            map: name,
            type: "geo",
            label: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false,
              },
            },
            roam: false,
            top: 42,
            bottom: 22,
            tooltip: {
              show: false,
            },
            itemStyle: {
              borderColor: "#8CDBF5", // 边界颜色
              borderWidth: 2, // 边界宽度
              areaColor: "#002B74",
              shadowColor: "rgba(63, 218, 255, 0.2)",
              shadowBlur: 6,
              shadowOffsetX: -5,
              shadowOffsetY: 5,
              emphasis: {
                // areaColor: "#0A94FF",
                // areaColor: "rgba(45, 225, 237, 0.9)",
                // shadowColor: "rgba(63, 218, 255, 0.2)",
              },
            },
            // 后背景
            zoom: 0.7, //放大效果
          },
          {
            map: name,
            type: "geo",
            label: {
              // 图形上的文本标签
              normal: {
                //前
                show: true,
                formatter: function (params) {
                  // console.log(params);
                  // return params.name + "\n确诊人数:0";
                },
                textStyle: {
                  color: "#fff",
                },
              },
              emphasis: {
                // 后
                show: true,
                textStyle: {
                  color: "#097593",
                  fontWeight: "bolder",
                },
              },
            },
            roam: false, // 是否开启滚轮缩放和拖拽漫游,默认为false（关闭），其他有效输入为true（开启），'scale'（仅开启滚轮缩放），'move'（仅开启拖拽漫游）
            top: 40,
            bottom: 25,
            tooltip: {
              show: true,
              // trigger: "none",

              trigger: "item",
              backgroundColor: "transparent",
              borderColor: "transparent",
              extraCssText: "z-index:100;color:#fff;",

              triggerOn: "mousemove", // 设置为鼠标移动触发
              confine: true, // 确保 tooltip 显示在图表区域内
              extraCssText: `z-index: 100;color: #fff;  /* 允许鼠标事件穿透 */`,
              formatter: (params, ticket, callback) => {
                // console.log(params,);
                // console.log(ticket);
                // console.log(callback);

                let cou = 0;
                //根据业务自己拓展要显示的内容
                var res = "";
                var name = params.name;
                // if ((this.Value).length != 0) {
                //     cou = this.Value.find((item, index) => params.name == item.name)?.value || 0
                //     this.setUser(name)
                // }
                var count = cou;
                // res = `<div style="width:209px; height:116px; padding: 10px; position: absolute; top: 0; left:0;  border-radius: 4px;background:url( ${require("../assets/imgTwo1.png")}) no-repeat center center /100% 100%;">
                //              <div style='color:#F4BD59; font-size: 14px;'>${name}</div>
                //              <div style="display: flex; align-items: center;padding-top: 6px;">
                //                <span style="font-size: 12px;font-family: 'PangMenZhengDao'">${count}</span>
                //              </div>
                //           </div>`;
                const hank = (name) => {
                  console.log("name:", name);
                };
                res = `<div class="mapItem"
                              style="
                              width:209px; 
                              height:116px; 
                              padding: 10px; 
                              position: absolute; 
                              top: 0; 
                              left:0; 
                              user-select: auto; /* 允许用户选择文本 */
                              pointer-events: auto; /* 允许鼠标事件穿透 */ 
                              border-radius: 4px;
                              z-index: 1000;
                              background:url(${require("../assets/imgTwo1.png")}) no-repeat center center /100% 100%;">
                              <img src=${require("../assets/imgmap2.png")} alt=""
                                style="width: 65px; height: 85px; border-radius: 10px; float: left;margin-right: 10px;">
                                <div style="font-size:12px;color: rgb(225, 225, 225,0.8);text-align:left;">
                                    <div style="font-size-adjust: 14px;color: #fff;margin-bottom: 1px;">高评分公司</div>
                                    <div style="margin-bottom: 0px;">服务人员：40人</div>
                                    <div style="margin-bottom: 2px;">服务对象：500人</div>
                                    <div>
                                        <button id="button1-${name}" class='button11' value="${name}"
                                            style="width: 14px; height:16px;background: url(${require("../assets/mapButton1.png")}) no-repeat center center /100% 100%;
                                            border: none;
                                            padding: 0;
                                            margin: 0;
                                            margin-right:5px;
                                            cursor: pointer;
                                            font-family: inherit;
                                            font-size: inherit;
                                            color: inherit;
                                            outline: none;
                                            "
                                            ></button>
                                        <button id="button2-${name}" class='button22' value="${name}"
                                            style="width: 14px; height: 16px;background: url(${require("../assets/mapButton2.png")}) no-repeat center center /100% 100%;
                                            border: none;
                                              padding: 0;
                                              margin: 0;
                                              cursor: pointer;
                                              font-family: inherit;
                                              font-size: inherit;
                                              color: inherit;
                                              outline: none;
                                            "></button>
                                        </div>
                                    </div>
                                </div>`;
                return res;
              },
              position: function (point, params, dom, rect, size) {
                // 固定在顶部
                let name = gdGeoCoordMap1[params.name];
                // console.log('name:', point[0] - 110, point[1] - 120);

                return [name[0], name[1]];
                return [point[0] - 110, point[1] - 120];
              },
              // position: ['50%', '50%']
            },
            itemStyle: {
              // borderColor: "rgba(255, 255, 255, 1)", // 边界颜色
              // borderColor: "rgba(45, 225, 237, 0.9)", // 边界颜色
              borderColor: "#8CDBF5", // 边界颜色
              borderWidth: 2, // 边界宽度
              // borderColor: "#fff", // 边界颜色
              // 前背景
              // areaColor: "rgba(40, 118, 185)",
              // areaColor: "rgba(29, 91, 159)",
              // areaColor: "#2380f1",
              // areaColor: "#007A7A",
              // areaColor: "#006262",
              // areaColor: "#07D2D5",
              // areaColor: "#005365",
              areaColor: "#002B74",
              shadowColor: "rgba(63, 218, 255, 0.2)",
              // shadowColor: "rgba(45, 225, 237, 0.1)",
              // shadowColor: "#151739",
              shadowBlur: 6,
              shadowOffsetX: -5,
              shadowOffsetY: 5,
              emphasis: {
                // areaColor: "#00808A",
                areaColor: "#0A94FF",
                areaColor: "rgba(45, 225, 237, 0.9)",
                shadowColor: "rgba(63, 218, 255, 0.2)",
              },
            },
            // 后背景

            zoom: 0.7, //放大效果
          },
        ],
        series: [
          // {
          //   type: "scatter",
          //   coordinateSystem: "geo",
          //   // symbol: 'image://' + require('../assets1/imgOne.png'),
          //   symbol: 'image://' + require('../assets/imgTwo.png'),
          //   symbolSize: [118, 84],
          //   symbolOffset: [0, '-50%'],
          //   rippleEffect: {
          //     period: 0,
          //     scale: 0,
          //     brushType: 'fill',
          //   },
          //   showEffectOn: "render",
          //   zlevel: 1,
          //   hoverAnimation: false,
          //   label: {
          //     normal: {
          //       formatter: " ",
          //       position: [0, 0],
          //       offset: [0, 0],
          //       color: "#1DE9B6",
          //       show: true,
          //       width: 32,
          //       height: 32,
          //       backgroundColor: {
          //         image: img2
          //       }
          //     },
          //   },
          //   itemStyle: {
          //     normal: {
          //       color: function (value) {
          //         //随机颜色
          //         return ("#" + ("00000" + ((Math.random() * 16777215 + 0.5) >> 0).toString(16)).slice(-6));
          //       },
          //       shadowBlur: 10,
          //       shadowColor: "#333",
          //     },
          //   },
          //   data: points,
          // },
          // {
          //   type: 'scatter',
          //   coordinateSystem: 'geo',
          //   itemStyle: {
          //     color: '#00FFF6',
          //   },
          //   // symbol: 'image://' + require('../assets/imgOne22.png'),
          //   symbolSize: [60, 160],
          //   symbolOffset: [0, -60],
          //   z: 999,
          //   data: convertData(points),
          // },
          //       {
          //         type: 'scatter',
          //         coordinateSystem: 'geo',
          //         label: {
          //           normal: {
          //             show: true,
          //             formatter: function (params) {
          //               var name = params.name
          //               var value = params.value[2]
          //               var text = `{tline|${name}}`
          //               // var text = `{fline|${value}人}\n{tline|${name}}`
          //               return text;
          //               var res = "";
          //               res = `<div class="mapItem"
          //                   style="width:209px; height:116px; padding: 10px; position: absolute; top: 0; left:0;  border-radius: 4px;background:url(${require("../assets/imgTwo1.png")}) no-repeat center center /100% 100%;">
          //                   <img src=${require("../assets/imgmap2.png")} alt=""
          //                     style="width: 65px; height: 85px; border-radius: 10px; float: left;margin-right: 10px;">
          //                     <div style="font-size:12px;color: rgb(225, 225, 225,0.8);text-align:left;">
          //                         <div style="font-size-adjust: 14px;color: #fff;margin-bottom: 1px;">高评分公司</div>
          //                         <div style="margin-bottom: 0px;">服务人员：40人</div>
          //                         <div style="margin-bottom: 2px;">服务对象：500人</div>
          //                         <div>
          //                             <button
          //                                 style="width: 14px; height: 16px;background: url(${require("../assets/mapButton1.png")}) no-repeat center center /100% 100%;
          //                                 border: none;
          //                                 padding: 0;
          //                                 margin: 0;
          //                                 cursor: pointer;
          //                                 font-family: inherit;
          //                                 font-size: inherit;
          //                                 color: inherit;
          //                                 outline: none;
          //                                 "></button>
          //                             <button
          //                                 style="width: 14px; height: 16px;background: url(${require("../assets/mapButton2.png")}) no-repeat center center /100% 100%;
          //                                 border: none;
          //                                   padding: 0;
          //                                   margin: 0;
          //                                   cursor: pointer;
          //                                   font-family: inherit;
          //                                   font-size: inherit;
          //                                   color: inherit;
          //                                   outline: none;
          //                                 "></button>
          //         </div>
          //     </div>
          // </div>`
          //               return res;
          //             },
          //             color: '#fff',
          //             rich: {
          //               fline: {
          //                 padding: [0, 25],
          //                 color: '#fff',
          //                 fontSize: 14,
          //                 fontWeight: 400
          //               },
          //               tline: {
          //                 padding: [0, 27],
          //                 // color: '#ABF8FF',
          //                 color: '#fff',
          //                 fontWeight: 600,
          //                 fontSize: 12,
          //               },
          //             }
          //           },
          //           emphasis: {
          //             show: true
          //           }
          //         },
          //         itemStyle: {
          //           color: '#00FFF6',
          //           formatter: (a) => {
          //             console.log('qq', a);
          //           }
          //         },
          //         symbol: 'image://' + require('../assets/imgOne_1.png'),//上
          //         symbolSize: [58, 26],
          //         symbolOffset: [0, -30],
          //         z: 999,
          //         data: convertData1(points),
          //       },
          // {
          //   tooltip: { show: false },
          //   type: 'effectScatter',
          //   coordinateSystem: 'geo',
          //   rippleEffect: {
          //     scale: 10,
          //     brushType: 'stroke',
          //   },
          //   showEffectOn: 'render',
          //   itemStyle: {
          //     normal: {
          //       color: '#00FFFF',
          //       color: 'yellow',
          //     }
          //   },
          //   // label: {
          //   //   normal: {
          //   //     color: '#fff',
          //   //   },
          //   // },
          //   label: {
          //     normal: {
          //       show: true,
          //       formatter: function (params) {
          //         var res = ''
          //         res = `<div class="mapItem"
          //                     style="width:209px; height:116px; padding: 10px; position: absolute; top: 0; left:0;  border-radius: 4px;background:url(${require("../assets/imgTwo1.png")}) no-repeat center center /100% 100%;">
          //                     <img src=${require("../assets/imgmap2.png")} alt=""
          //                       style="width: 65px; height: 85px; border-radius: 10px; float: left;margin-right: 10px;">
          //                       <div style="font-size:12px;color: rgb(225, 225, 225,0.8);text-align:left;">
          //                           <div style="font-size-adjust: 14px;color: #fff;margin-bottom: 1px;">高评分公司</div>
          //                           <div style="margin-bottom: 0px;">服务人员：40人</div>
          //                           <div style="margin-bottom: 2px;">服务对象：500人</div>
          //                           <div>
          //                               <button
          //                                   style="width: 14px; height: 16px;background: url(${require("../assets/mapButton1.png")}) no-repeat center center /100% 100%;
          //                                   border: none;
          //                                   padding: 0;
          //                                   margin: 0;
          //                                   cursor: pointer;
          //                                   font-family: inherit;
          //                                   font-size: inherit;
          //                                   color: inherit;
          //                                   outline: none;
          //                                   "></button>
          //                               <button
          //                                   style="width: 14px; height: 16px;background: url(${require("../assets/mapButton2.png")}) no-repeat center center /100% 100%;
          //                                   border: none;
          //                                     padding: 0;
          //                                     margin: 0;
          //                                     cursor: pointer;
          //                                     font-family: inherit;
          //                                     font-size: inherit;
          //                                     color: inherit;
          //                                     outline: none;
          //                                   "></button>
          //                                 </div>
          //                             </div>
          //                         </div>`
          //         // return `<div>13456786r</div>`
          //         // return res;
          //         return ''
          //         // return '{fline|客户：' + params.data.username + '  ' + params.data.telphone + '}\n{tline|' + params.data.address + '}';
          //       },
          //       position: 'top',
          //       // backgroundColor: 'rgba(254,174,33,.8)',
          //       padding: [0, 0],
          //       borderRadius: 3,
          //       lineHeight: 32,
          //       color: '#f7fafb',
          //       rich: {
          //         fline: {
          //           padding: [0, 10, 10, 10],
          //           color: '#ffffff'
          //         },
          //         tline: {
          //           padding: [10, 10, 0, 10],
          //           color: '#ffffff'
          //         }
          //       }
          //     },
          //     emphasis: {
          //       show: true
          //     }
          //   },
          //   symbol: 'circle',
          //   symbolSize: [3, 3],
          //   data: convertData1(points),
          //   zlevel: 1,
          // },
        ],
      };
      myChart.on("click", function (params) {
        if (params.name) {
          that.selectName = params.name;
          that.$emit("setMapInfo", params.name);
          // console.log('params.name:', that.citys[params.name]);
          // that.arrRetrun.push(params.name)
          // that.initNYNM(params.name, that.citys[params.name])
        }
        // const tooltipDom = document.querySelector('.mapItem');
        // const button1 = document.getElementById(`button1-${params.name}`);
        // const button2 = document.getElementById(`button2-${params.name}`);
        // if (button1) {
        //   console.log('这是1个button：', button1);
        //   button1.onclick = () => {
        //     console.log('点击了11个button：', button1);
        //   }
        //   button1.addEventListener('click', function (e) {
        //     console.log(222);

        //     e.stopPropagation(); // 阻止事件冒泡，避免触发地图点击事件
        //     console.log(`Button 1 clicked for ${params.name}`);
        //     // 在这里添加按钮 1 的点击处理逻辑
        //   });
        // }
        // button1.addEventListener('click', function (e) {
        //   e.stopPropagation(); // 阻止事件冒泡，避免触发地图点击事件
        //   console.log(`Button 1 clicked for ${params.name}`);
        //   // 在这里添加按钮 1 的点击处理逻辑
        // });

        // if (button2) {
        //   button2.addEventListener('click', function (e) {
        //     e.stopPropagation(); // 阻止事件冒泡，避免触发地图点击事件
        //     console.log(`Button 2 clicked for ${params.name}`);
        //     // 在这里添加按钮 2 的点击处理逻辑
        //   });
        // }
      });
      let tooltipClickListener11 = null;
      let tooltipClickListener22 = null;

      myChart.on("showTip", function (param) {
        const tooltipDom = document.querySelector(".mapItem");
        const button11 = tooltipDom.querySelector(".button11");
        const button22 = tooltipDom.querySelector(".button22");

        // 移除之前绑定的事件
        if (tooltipClickListener11) {
          button11.removeEventListener("click", tooltipClickListener11);
        }
        if (tooltipClickListener22) {
          button11.removeEventListener("click", tooltipClickListener22);
        }

        tooltipClickListener11 = function (e) {
          e.stopPropagation(); // 阻止事件冒泡，避免触发地图点击事件
          console.log(`Button 1 clicked for ${button11.value}`);
          // 在这里添加按钮 1 的点击处理逻辑
        };
        tooltipClickListener22 = function (e) {
          e.stopPropagation(); // 阻止事件冒泡，避免触发地图点击事件
          console.log(`Button 2 clicked for ${button22.value}`);
          // 在这里添加按钮 2的点击处理逻辑
        };
        // 绑定新的事件
        button11.addEventListener("click", tooltipClickListener11);
        button22.addEventListener("click", tooltipClickListener22);
      });

      myChart.on("hideTip", function (params) {
        // console.log('鼠标移出:', params.name);
        return;
        const tooltipDom = document.querySelector(".echarts-tooltip");
        if (tooltipDom) {
          tooltipDom.removeEventListener("mousemove", function () {});
        }
        const button1 = document.getElementById(`button1-${params.name}`);
        const button2 = document.getElementById(`button2-${params.name}`);

        if (button1) {
          button1.removeEventListener("click", function () {});
        }

        if (button2) {
          button2.removeEventListener("click", function () {});
        }
      });

      // myChart.on("click", function (param) {
      //   if (param.name) {
      //     location.href = " ./search.html";
      //   }
      // });

      // 3. 把配置给实例对象

      myChart.setOption(option);

      /* 轮播 */
      // 启动 tooltip 轮播
      // this.tooltipInterval = setInterval(() => {
      //   this.showNextTooltip(myChart);
      //   // console.log('myChart:', myChart);
      // }, 3000); // 每 3 秒切换一次

      // 监听 ECharts 渲染完成事件
      // myChart.on('finished', () => {
      //   // 启动区域高亮循环
      //   // 组件销毁时清除定时器
      //   console.log('nisnL');

      //   if (this.highlightInterval) {
      //     clearInterval(this.highlightInterval);
      //   }

      // });

      this.highlightInterval = setInterval(() => {
        this.highlightNextArea(myChart);
      }, 5000); // 每 5 秒切换一次高亮区域

      // 监听鼠标移入地图区域事件
      myChart.on("mouseover", (params) => {
        // console.log('鼠标移入地图区域');
        if (this.highlightInterval) {
          clearInterval(this.highlightInterval);
          this.highlightInterval = null;
        }
      });

      // 监听鼠标移出地图区域事件
      myChart.on("mouseout", (params) => {
        if (!this.highlightInterval) {
          this.highlightInterval = setInterval(() => {
            this.highlightNextArea(myChart);
          }, 2000);
        }
      });

      // 4. 让图表跟随屏幕自动的去适应
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    showNextTooltip(myChart) {
      const areaName = this.areaNames[this.currentIndex];
      // 查找对应的数据索引
      let dataIndex = -1;
      // 获取 geo 组件数据
      const geo = myChart.getOption().geo;
      if (geo) {
        for (let i = 0; i < geo.length; i++) {
          if (geo[i].data) {
            dataIndex = geo[i].data.findIndex((item) => item.name === areaName);
            if (dataIndex !== -1) {
              // 触发 tooltip 显示
              myChart.dispatchAction({
                type: "showTip",
                geoIndex: i,
                dataIndex: dataIndex,
              });
              break;
            }
          }
        }
      }

      // 切换到下一个区域
      this.currentIndex = (this.currentIndex + 1) % this.areaNames.length;
    },

    highlightNextArea(myChart) {
      const areaName = this.areaNames[this.currentIndex];

      // 先取消上一个区域的高亮
      if (this.prevAreaName) {
        myChart.dispatchAction({
          type: "downplay",
          geoIndex: 3,
          name: this.prevAreaName,
        });
      }

      // 高亮当前区域
      myChart.dispatchAction({
        type: "highlight",
        geoIndex: 3,
        name: areaName,
      });
      myChart.dispatchAction({
        type: "showTip",
        geoIndex: 3,
        name: areaName,
      });

      this.prevAreaName = areaName;

      // 切换到下一个区域
      this.currentIndex = (this.currentIndex + 1) % this.areaNames.length;
    },
  },
  beforeDestroy() {
    // 组件销毁时清除定时器
    if (this.tooltipInterval) {
      clearInterval(this.tooltipInterval);
    }

    // 组件销毁时清除定时器
    if (this.highlightInterval) {
      clearInterval(this.highlightInterval);
    }
  },
};
</script>
<style scoped lang="less">
.container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

#chinaMapbox {
  transform: rotateX(20deg);
  /* transform: rotateX(45deg); */
  height: 125%;
  /* height: 125%; */
  width: 100%;
  /* height: 100% */
}

/* 重置 button 样式 */
.button {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  font-family: inherit;
  font-size: inherit;
  color: inherit;
  outline: none;
}

/* 保留原有的 button 背景图片样式 */
button[style*="background: url"] {
  width: 14px;
  height: 16px;
  background-repeat: no-repeat;
  background-position: center center;
}

.mapInfodiv {
  position: absolute;
  width: 171px;
  height: 79px;
  background: url(../assets/mapInfobg.png) no-repeat center center / 100% 100%;
  color: #d2ffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 10px;

  .name {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    line-height: 20px;
    text-align: left;
    font-style: normal;

    span {
      color: #f5a623;
      font-size: 20px;
      font-weight: 700;
    }
  }

  .value {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 24px;
    color: #d2ffff;
    line-height: 33px;
    text-align: left;
    font-style: normal;
  }
}

.mapItem {
  width: 209px;
  height: 116px;
  padding: 10px;
  position: absolute;
  top: 0;
  left: 0;
  border: #f5a623 1px solid !important;
  border-radius: 4px;
  background: url(../assets/imgTwo1.png) no-repeat center center / 100% 100%;
}
</style>
